<template>
    <modal name="change-category-modal" @before-open="beforeOpen" :resizable="true" transition="pop-out" :width="600" :height="275">
        <h4 class="text-center panel-heading">Producten overzetten</h4>
        <div class="row">
            <div class="col-sm-12">
                <div class="col-sm-12">
                    <p class="text-center">Selecteer de categorie waar deze producten onder horen. </p>
                </div>
            </div>
        </div>
        <form @submit.prevent="changeCategory()">
            <div class="col-sm-12 mb-20">
                <label>Categorie</label>
                <vue-select v-model="desiredCategory" label="dutchTranslation" :options="assignableCategories"></vue-select>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="col-sm-4">
                        <button type="submit" class="btn btn-danger">Overzetten</button>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>
<script>
    import { mapGetters } from 'vuex'
    import * as types from '../../store/mutation-types'
    import VueSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    export default {
        name: 'ChangeCategory',
        components: {
            VueSelect
        },
        data() {
            return {
                currentCategory: '',
                desiredCategory: ''
            }
        },
        methods: {
            beforeOpen(event) {
                if (event.params.category) {
                    this.currentCategory = event.params.category
                }
                this.$store.dispatch('getAssignableCategories')
            },
            changeCategory() {
                this.$store.commit(types.SET_CATEGORY_TO_SWITCH, { currentCategory: this.currentCategory, desiredCategory: this.desiredCategory })
                this.$store.dispatch('switchCategory').then(() => {
                    if (this.isCategorySwitched) {
                        this.$store.commit(types.SET_PRODUCTS, [])
                        this.$modal.hide('change-category-modal')
                    } else {
                        this.$notify({ group: 'danger', type: 'error', title: 'Error', text: 'Er is iets fout gegaan bij het overzetten van de producten!' })
                    }
                })
            }
        },
        computed: {
            ...mapGetters({
                assignableCategories: 'assignableCategories',
                isCategorySwitched: 'isCategorySwitched'
            })
        }
    }
</script>

<style scoped>
    .mb-20 {
        margin-bottom: 20px;
    }
</style>
